/* eslint-disable react/no-array-index-key,jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */
import React, {Component} from 'react';
import classnames from 'classnames';
import sortBy from 'lodash.sortby';
import {Tooltip} from 'components/Tooltip';

import {InfoIcon} from 'icons';
import {formatStrategyOutcome} from 'components/Cards/Strategy/helpers';
import './strategy-stats.scss';

class StrategyStats extends Component {
  state = {
    selected: 0,
  };

  componentDidMount() {
    this.setState({selected: this.props.results.length - 1});
  }

  renderHeading = () => (
    <div className="strategy-stats-heading">
      {sortBy(this.props.results, ({name}) => name)
        .map(({name}, i) => {
          const isSelected = this.state.selected === i;
          const isFirst = i === this.props.results.length - 1;
          return (
            <div
              key={i}
              className={classnames('stats-heading-text', {
                first: isFirst,
                selected: isSelected,
              })}
              onClick={() => this.setState({selected: i})}
            >
              {name}
            </div>
          );
        })
        .reverse()}
    </div>
  );

  render() {
    const {results} = this.props;
    const {roi, winRate, avgOdds, balance, data = []} = results[this.state.selected];

    return (
      <div className="strategy-stats">
        {this.renderHeading()}
        <div className="strategy-details second">
          <div className="grid">
            <div className="strategy-box balance">
              <div>Balance</div>
              <Tooltip text="Balance is calculated by placing virtual $100 on each pick" className="tooltip-balance">
                <div className="info-icon">
                  <InfoIcon />
                </div>
              </Tooltip>
            </div>
            <div className="strategy-box stat-value current-season">
              <div
                className={classnames({
                  'stat-value current': true,
                  green: balance >= 0,
                  red: balance < 0,
                })}
              >
                {formatStrategyOutcome(balance)}
              </div>
            </div>
            <div className="strategy-box">ROI</div>
            <div className="strategy-box current-season">
              <div
                className={classnames({
                  'stat-value current': true,
                  green: roi > 5,
                  red: !(roi > 5),
                })}
              >
                {roi}%
              </div>
            </div>
            <div className="strategy-box f">Avg odds</div>
            <div className="strategy-box stat-value current-season">{avgOdds}</div>
            <div className="strategy-box">Picks</div>
            <div className="strategy-box stat-value current-season">{data.length}</div>
            <div className="strategy-box">Win Rate</div>
            <div className="strategy-box stat-value current-season">{winRate}%</div>
          </div>
        </div>
      </div>
    );
  }
}

export default StrategyStats;
